var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 16 14",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    transform: "translate(2.250002 3.000002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.84098812.65900812c.8786775.8786775.8786775 2.3033025 0 3.18198-.87867749.8786775-2.3033025.8786775-3.18198 0-.8786775-.87867749-.8786775-2.3033025 0-3.18198s2.3033025-.8786775 3.18198 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.749998 2.249998h-8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8409731 8.15902313c.8786775.8786775.8786775 2.30330247 0 3.18197997s-2.3033025.8786775-3.18197998 0c-.8786775-.8786775-.8786775-2.30330247 0-3.18197997.87867748-.8786775 2.30330248-.8786775 3.18197998 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.749998 9.749998h8.25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSecond);
export default __webpack_public_path__ + "static/media/filter-second.58958918803c0903f4ff51ff79171c92.svg";
export { ForwardRef as ReactComponent };